/** Lightweight inline SVG sparkline. */
export default function Sparkline({ data = [], width = 100, height = 24, color = "var(--accent-2)", testId }) {
  if (!data || data.length < 2) {
    return <svg width={width} height={height} data-testid={testId}>
      <line x1="0" y1={height / 2} x2={width} y2={height / 2} stroke="var(--border-2)" strokeWidth="1" strokeDasharray="2,2" />
    </svg>;
  }
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const step = width / Math.max(1, data.length - 1);
  const points = data.map((v, i) => {
    const x = i * step;
    const y = height - 2 - ((v - min) / range) * (height - 4);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  const lastX = (data.length - 1) * step;
  const lastY = height - 2 - ((data[data.length - 1] - min) / range) * (height - 4);
  return (
    <svg width={width} height={height} data-testid={testId} style={{ overflow: "visible" }}>
      <polyline fill="none" stroke={color} strokeWidth="1.5" points={points} />
      <circle cx={lastX} cy={lastY} r="2" fill={color} />
    </svg>
  );
}
